<template>
  <v-row>
    <v-col cols="6" class="mt-0 mb-1 pb-0 pt-2">
      <v-text-field
        clearable
        class="flex-md-grow-1"
        dense
        outlined
        filled
        autocomplete="off"
        :label="left_label"
        :prepend-inner-icon="left_icon"
        :disabled="disabled"
        v-model="local_left_value"
        :rules="left_validation_rules"
        :required="left_required"
        :type="left_type"
        v-if="left_type != 'phone'"
      ></v-text-field>
      <vue-tel-input-vuetify
        clearable
        class="flex-md-grow-1"
        dense
        outlined
        filled
        autocomplete="off"
        :label="left_label"
        :disabled="disabled"
        :required="left_required"
        v-if="left_type == 'phone'"
        @input="on_left_phone_input"
        v-model="local_left_value"
        :valid-characters-only="true"
        :inputOptions="{ showDialCode: false }"
        :error-messages="right_phone_error_messages"
        :rules="left_validation_rules"
      ></vue-tel-input-vuetify>
    </v-col>
    <v-col cols="6" class="mt-0 mb-1 pb-0 pt-2">
      <v-text-field
        clearable
        class="flex-md-grow-1"
        dense
        outlined
        filled
        autocomplete="off"
        :label="right_label"
        :prepend-inner-icon="right_icon"
        :disabled="disabled"
        v-model="local_right_value"
        :rules="right_validation_rules"
        :required="right_required"
        :type="right_type"
        v-if="right_type != 'phone'"
      ></v-text-field>

      <vue-tel-input-vuetify
        clearable
        class="flex-md-grow-1"
        dense
        outlined
        filled
        autocomplete="off"
        :label="right_label"
        :disabled="disabled"
        :required="right_required"
        v-if="right_type == 'phone'"
        v-model="local_right_value"
        @input="on_right_phone_input"
        :valid-characters-only="true"
        :inputOptions="{ showDialCode: false }"
        :error-messages="right_phone_error_messages"
        :rules="right_validation_rules"
      ></vue-tel-input-vuetify>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TwoTextFields",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    left_label: {
      type: String,
      default: "",
    },
    left_icon: {
      type: String,
      default: "mdi-pencil",
    },
    left_required: {
      type: Boolean,
      default: false,
    },
    left_value: {
      type: String,
      default: "",
    },
    left_prop: {
      type: String,
      default: "",
    },
    left_validation_rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    right_label: {
      type: String,
      default: "",
    },
    right_icon: {
      type: String,
      default: "mdi-pencil",
    },
    right_required: {
      type: Boolean,
      default: false,
    },
    right_value: {
      type: String,
      default: "",
    },
    right_validation_rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    right_prop: {
      type: String,
      default: "",
    },
    right_type: {
      type: String,
      default: "text",
    },
    left_type: {
      type: String,
      default: "text",
    },
  },
  data: () => {
    return {
      left_phone: {
        number: "",
        valid: false,
        country: undefined,
      },
      left_phone_error_messages: [],
      right_phone: {
        number: "",
        valid: false,
        country: undefined,
      },
      right_phone_error_messages: [],
    };
  },
  computed: {
    local_left_value: {
      get() {
        return this.left_value;
      },
      set(new_value) {
        this.$emit("input", { value: new_value, prop: this.left_prop });
      },
    },
    local_right_value: {
      get() {
        //console.log("get one: ", this.right_value, this.right_phone);
        return this.right_value;
      },
      set(new_value) {
        //console.log("set one: ", this.right_value, this.right_phone);
        this.$emit("input", { value: new_value, prop: this.right_prop });
      },
    },
  },
  methods: {
    on_left_phone_input(formattedNumber, { number, valid, country }) {
      this.on_phone_input("left", number, valid, country);
    },
    on_right_phone_input(formattedNumber, { number, valid, country }) {
      //console.log("the number is ", formattedNumber, number);
      this.on_phone_input("right", number, valid, country);
    },
    on_phone_input(side, number, valid, country) {
      // console.log("danger one: ", side);
      var side_prop = side + "_prop";
      var phone_prop = side + "_phone";
      var error_messages_prop = side + "_phone_error_messages";
      //https://github.com/yogakurniawan/vue-tel-input-vuetify-example/blob/master/src/components/Example.vue
      this[phone_prop].number = number.international;
      this[phone_prop].valid = valid;
      this[phone_prop].country = country && country.name;
      this[error_messages_prop] = [];
      var new_value = "";
      var phone =
        this[phone_prop] && this[phone_prop].number
          ? this[phone_prop].number
          : "Input";
      new_value = phone;
      if (this[phone_prop].valid == false && this[phone_prop].number != undefined) {
        this[error_messages_prop] = [
          phone +
            " is not a valid " +
            this[phone_prop].country +
            " phone number",
        ];
      }
      var val = new_value == "Input" ? "" : new_value;
      //console.log("The new_value value:", this[phone_prop]);
      this.$emit("input", {
        value: val.trim().replaceAll(" ", ""),
        prop: this[side_prop],
        valid: this[phone_prop].valid,
      });
    },
  },
};
</script>